var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import AppointmentDetailAPI from './appointment-detail-api';
import Avatar from '@philips-internal/oswald-ui-components/lib/components/avatar/avatar';
import { ScheduleStatus } from '../physician-schedule-card/schedule-status';
import { ReactComponent as Approved } from '../../assets/images/global/calendar-check-gray.svg';
import { ReactComponent as Available } from '../../assets/images/global/circle-stroke.svg';
import { ReactComponent as Blocked } from '../../assets/images/global/block.svg';
import { ReactComponent as Canceled } from '../../assets/images/global/canceled.svg';
import { ReactComponent as Confirmed } from '../../assets/images/global/calendar-check.svg';
import { ReactComponent as Done } from '../../assets/images/global/done.svg';
import { ReactComponent as WaitingApprove } from '../../assets/images/global/clock.svg';
import { ReactComponent as Lost } from '../../assets/images/global/patient-cancel.svg';
import { ReactComponent as NotApprovedByInsurance } from '../../assets/images/global/close-cross-circle.svg';
import { ReactComponent as Calendar } from '../../assets/images/global/schedule.svg';
import { ReactComponent as Call } from '../../assets/images/global/phone.svg';
import { ReactComponent as Mail } from '../../assets/images/global/send-message.svg';
import './appointment-detail.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let AppointmentDetail = class AppointmentDetail extends Component {
    renderAvatar() {
        const { personName, personPhotoBase64 } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("hr", { className: 'c-appointment-detail-line' })),
            React.createElement("div", { className: "c-appointment-detail__avatar" },
                React.createElement(Avatar, { title: personName ? personName : '', subtitle: MessageService.translate('label-appointments.patient'), image: personPhotoBase64 })),
            React.createElement("div", null,
                React.createElement("hr", { className: 'c-appointment-detail-line' }))));
    }
    renderIcon(scheduleStatusCode) {
        switch (scheduleStatusCode) {
            case ScheduleStatus.AVAILABLE:
                return React.createElement(Available, null);
            case ScheduleStatus.DONE:
                return React.createElement(Done, null);
            case ScheduleStatus.CANCELED:
                return React.createElement(Canceled, null);
            case ScheduleStatus.LOST:
                return React.createElement(Lost, null);
            case ScheduleStatus.WAITING_APPROVE:
                return React.createElement(WaitingApprove, null);
            case ScheduleStatus.NOT_APPROVED_BY_INSURANCE:
                return React.createElement(NotApprovedByInsurance, null);
            case ScheduleStatus.CONFIRMED_BY_CLIENT:
                return React.createElement(Confirmed, null);
            case ScheduleStatus.APPROVED:
                return React.createElement(Approved, null);
            default:
                return React.createElement(Blocked, null);
        }
    }
    renderContent() {
        const { scheduleTypeDescription, scheduleStatusCode, scheduleStatusDescription } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-appointment-detail__content' },
                React.createElement("div", { className: 'c-appointment-detail__content-right' },
                    React.createElement(Calendar, null)),
                React.createElement("div", { className: 'c-appointment-detail__content-left' },
                    React.createElement("span", { className: 'c-appointment-detail-title' }, MessageService.translate('label.appointment-type')),
                    React.createElement("span", { className: 'c-appointment-detail-description' }, scheduleTypeDescription))),
            React.createElement("div", { className: 'c-appointment-detail__content' },
                React.createElement("div", { className: 'c-appointment-detail__content-right' }, this.renderIcon(scheduleStatusCode)),
                React.createElement("div", { className: 'c-appointment-detail__content-left' },
                    React.createElement("span", { className: 'c-appointment-detail-title' }, MessageService.translate('label.status')),
                    React.createElement("span", { className: 'c-appointment-detail-description' }, scheduleStatusDescription))),
            React.createElement("div", null,
                React.createElement("hr", { className: 'c-appointment-detail-line' }))));
    }
    renderAddressInformation() {
        const { personPhoneNumber, personEmail } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-appointment-detail__content' },
                React.createElement("div", { className: 'c-appointment-detail__content-right' },
                    React.createElement(Call, null)),
                React.createElement("div", { className: 'c-appointment-detail__content-left' },
                    React.createElement("span", { className: 'c-appointment-detail-title' }, MessageService.translate('$expression.$299149')),
                    React.createElement("span", { className: 'c-appointment-detail-description' }, personPhoneNumber || '--'))),
            React.createElement("div", { className: 'c-appointment-detail__content' },
                React.createElement("div", { className: 'c-appointment-detail__content-right' },
                    React.createElement(Mail, null)),
                React.createElement("div", { className: 'c-appointment-detail__content-left' },
                    React.createElement("span", { className: 'c-appointment-detail-title' }, MessageService.translate('$expression.$680093')),
                    React.createElement("span", { className: 'c-appointment-detail-description' }, personEmail || '--')))));
    }
    render() {
        return (React.createElement("div", { className: 'c-appointment-detail' },
            this.renderAvatar(),
            this.renderContent(),
            this.renderAddressInformation()));
    }
};
AppointmentDetail = __decorate([
    AwesomeComponent({ api: AppointmentDetailAPI, type: ComponentType.DATA_DISPLAY })
], AppointmentDetail);
export default AppointmentDetail;
//# sourceMappingURL=appointment-detail.js.map